import {Link} from "react-router-dom";
import makeStyles from '@mui/styles/makeStyles';
import { convertObjectIntoQueryString, generatePathAward, generatePathCategory, } from '../../Utils/Routes'
import CategoryBlock from "./CategoryBlock";

const useStyles = makeStyles(theme => ({
    lineHover: {
        color: theme.palette.secondary.contrastText,
        textDecoration: 'none',
        '&:hover': {
            textDecoration: 'none'
        }
    },
}));


export function EntryCategoryLinkBlock({ entry, awardId, category }) {

    const classes = useStyles();

    const localFilters = {
        categoriesSelected: [category.id],
    }
    
    const baseEntryLink = entry.hasCategoryPage 
        ? generatePathCategory(awardId, category.id) 
        : generatePathAward(awardId)
    
    const linkUrl = baseEntryLink + "?" + convertObjectIntoQueryString({}, localFilters);

    return (
        <Link to={linkUrl} className={classes.lineHover}>
            <CategoryBlock 
                padding="12px 16px 8px" 
                heading={category.title} 
                text={category.candidateForNomination}
            />
        </Link>
    )
}

export function EntryTagLinkBlock({ entry, awardId, categoryId, tagName }) {

    const classes = useStyles();

    const localFilters = {
        tagsSelected: [tagName.toLocaleUpperCase()],
    }
    
    const baseEntryLink = entry.hasCategoryPage 
        ? generatePathCategory(awardId, categoryId) 
        : generatePathAward(awardId)
    
    const linkUrl = baseEntryLink + "?" + convertObjectIntoQueryString({}, localFilters);

    return (
        <Link to={linkUrl} className={classes.lineHover}>
            <CategoryBlock 
                padding="12px 16px 8px" 
                heading={tagName}
            />
        </Link>
    )
}